import Vue from 'vue';
import Vuex, { Payload } from 'vuex';
import VuexPersist from 'vuex-persist';
import { loginStore } from './loginStore';
import { navigationStore } from './navigationStore';
import { googleStore } from './googleStore';

// do not persist store, if the state is changed by changeOrAdd mutations with these keys
const ignoreMutationKeys = ['maxFilesReached', 'maxFileSizeReached'];
const ignoreMutationModules = ['googleStore'];

const vuexPersist = new VuexPersist({
	key: 'olb',
	storage: window.localStorage,
	filter: (mutation: Payload | any) => {
		if (mutation.payload && mutation.payload.key) {
			return !ignoreMutationKeys.includes(mutation.payload.key);
		}
		if (mutation.type) {
			ignoreMutationModules.forEach((ignoredModule: string) => {
				if (mutation.type.includes(ignoredModule)) {
					return false;
				}
			});
		}
		return true;
	},
});

Vue.use(Vuex);

export const store = new Vuex.Store({
	state: {
		data: {},
	},
	mutations: {
		changeOrAdd(state, { key, value }) {
			Vue.set(state.data, key, value);
		},
	},
	modules: {
		loginStore,
		navigationStore,
		googleStore,
	},
	plugins: [vuexPersist.plugin],
});

export default store;
